export const exterior_view02ImageOptions = {
  angle: 'exterior_view02',
  staticOptions: {
    HullColour: 1,
    BowSprit: 1,
    HullTreatment: 1,
    Deck: 1,
    TeakOnSideDecks: 1,
    TeakOnCoachroof: 1,
    SprayHood: 1,
    BiminiForHelmsman: 1,
    BiminiForForwardCockpit: 1,
    CockpitTent: 1,
    Wheel: 1,
    MastAndBoom: 1,
    BoomCover: 1,
    LiftingArm: 1,
    Gangway: 1,
    AftBench: 1,
    SolarPanels: 1,
    WheelingSeats: 1,
    Boom: 1
  },
  mattes: [
    {
      option: 'HullColour',
      dependency: null
    },
    {
      option: 'BowSprit',
      dependency: 'HullColour'
    },
    {
      option: 'Deck',
      dependency: 'AftBench'
    },
    {
      option: 'TeakOnSideDecks',
      dependency: 'Deck'
    },
    {
      option: 'TeakOnCoachroof',
      dependency: 'Deck'
    }
  ]
}



// WEBPACK FOOTER //
// ./src/X56/views/exterior_view02.js